import DaisyController from '../daisy/daisy.controller';

/**
 * home controller
 **/
export default class HomeController extends DaisyController {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.AuthService = $injector.get('AuthService');
		this.$rootScope = $injector.get('$rootScope');
	}

	/**
	 * initialize the component and define the component description object
	 **/
	$onInit() {
		this.component = {
			title: 'Home',
			icon: ''
		};
	}

	/**
	 * the component is ready so we can update the toolbar
	 **/
	$routerOnActivate(next, prev) {
		this.$rootScope.$broadcast('toolbar:updateTitle', this.component);
	}

	/**
	 * static method to check if the user is authenticated
	 * @param {function} - $injector to inject all services
	 * @param {string} [path="Login"] - the path to navigate to if the user is not authenticated
	 * @return {promise} with true/false
	 **/
	static $canActivate($injector, path = 'Login') {
		const $rootRouter = $injector.get('$rootRouter');
		const AuthService = $injector.get('AuthService');
		const ToastService = $injector.get('ToastService');

		return AuthService.isAuthenticated().then((response) => {
			if (response) {
				return response;
			}
			$rootRouter.navigate([path]);
			ToastService.danger('Zugriff verweigert. Bitte melden Sie sich an.');
			return false;
		}, (err) =>  {
			$rootRouter.navigate([path]);
			return false;
		});
	}

}
